var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('div',{staticClass:"router-view",class:_vm.contentClass,style:({ minHeight: _vm.contentHeight })},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }